<script context='module'>
  import { getContext } from 'svelte';
  import { utilities } from '@commercebear/portal-api';

  export const IS_ADMIN = Symbol('IsAdmin');
  export const useIsAdmin = () => getContext(IS_ADMIN);
</script>

<script>
  import { derived } from 'svelte/store';
  import Provider from '@commercebear/components/Provider';
  import { getStores } from '$app/stores';

  const { page: pageStore } = getStores();

  const isAdminStore = derived([pageStore], ([page]) => {
    const hasAdminRole = utilities.isAdmin(page.data.session.user?.role);
    const isViewingAsAdmin = utilities.isAdmin(page.data.session.user?.settings?.viewAs);

    return hasAdminRole && isViewingAsAdmin;
  });
</script>

<Provider key={IS_ADMIN} value={isAdminStore}>
  <slot />
</Provider>
